module.exports = __webpack_public_path__ + "static/media/new.5a7a4938.svg";